"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = reducer;
const R = __importStar(require("ramda"));
const RefNumber = __importStar(require("@genesys/shared/lib/ref-number"));
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const Guid = __importStar(require("@genesys/shared/lib/guid"));
const initialState = {
    /* REMOVE this is for test */
    openTabs: [],
    messages: [],
    errorDialog: { showDetails: false, hasSubmitted: false }
};
function reducer(state = initialState, action) {
    switch (action.type) {
        case "tabs/ACTIVATE_TAB": {
            return Object.assign(Object.assign({}, state), { selectedTab: action.payload.id });
        }
        case "global-actions/REQUEST_OPEN_TAB": {
            return state;
        }
        case "global-actions/TAB_OPENED": {
            const openTabSpec = action.payload.openTabSpecification;
            const newTab = {
                id: openTabSpec.id,
                title: openTabSpec.title || "",
                subject: openTabSpec.subject
            };
            return Object.assign(Object.assign({}, state), { openTabs: state.openTabs.concat(newTab), selectedTab: newTab.id });
        }
        case "global-actions/TAB_ACTIVATED":
            const activeTab = state.openTabs.find(ot => ot === action.payload);
            if (!activeTab) {
                throw new Error(`Activated tab "${action.payload}" is missing`);
            }
            return Object.assign(Object.assign({}, state), { selectedTab: activeTab.id });
        case "global-actions/TAB_REMOVE_TAB":
            return Object.assign(Object.assign({}, state), { openTabs: state.openTabs.filter(ot => ot !== action.payload) });
        case "global-actions/ERROR":
            const errorInfo = action.payload;
            let systemInformation = "";
            systemInformation += "Browser name: " + navigator.appName + "\n";
            systemInformation += "Browser engine: " + navigator.product + "\n";
            systemInformation +=
                "Browser version: " +
                    navigator.appVersion +
                    " / " +
                    navigator.userAgent +
                    "\n";
            systemInformation += "Browser platform: " + navigator.platform + "\n";
            systemInformation += "Browser language: " + navigator.language + "\n";
            systemInformation += "Online: " + navigator.onLine + "\n";
            systemInformation +=
                "Screen size: " + screen.width + " x " + screen.height + "\n";
            systemInformation += "Accept cookies: " + navigator.cookieEnabled + "\n";
            systemInformation +=
                "Timezone: " + new Date().getTimezoneOffset() / 60 + "\n";
            systemInformation += "Current page: " + window.location.pathname + "\n";
            if (state.selectedTab) {
                const selectedTab = state.openTabs.find(t => Guid.guidEquals(t.id, state.selectedTab));
                systemInformation +=
                    "Current tab: " +
                        selectedTab.title +
                        " (" +
                        JSON.stringify(selectedTab.subject) +
                        ")";
            }
            return Object.assign(Object.assign({}, state), { exceptionReport: {
                    referenceNo: RefNumber.newRefNumber(),
                    title: errorInfo.message || "",
                    content: errorInfo.exception || "",
                    systemInformation: systemInformation
                } });
        case "main/TOGGLE_ERROR_DETAILS":
            return Object.assign(Object.assign({}, state), { errorDialog: Object.assign(Object.assign({}, state.errorDialog), { showDetails: !state.errorDialog.showDetails }) });
        case "main/SUBMIT_ERROR_REPORT_COMPLETED":
            return Object.assign(Object.assign({}, state), { errorDialog: Object.assign(Object.assign({}, state.errorDialog), { hasSubmitted: true }) });
        case "main/RESOURCES_LOADED":
        case "main/MESSAGE":
        case "tabs/REQUEST_REMOVE_TAB":
            return state;
        case "global-actions/UPDATE_TAB_TITLE": {
            const tab = state.openTabs.find(t => Guid.guidEquals(t.id, action.id));
            if (!tab) {
                return state;
            }
            const updatedTab = Object.assign(Object.assign({}, tab), { title: action.title });
            return Object.assign(Object.assign({}, state), { openTabs: R.update(state.openTabs.indexOf(tab), updatedTab, state.openTabs) });
        }
        default:
            (0, ts_exhaustive_check_1.exhaustiveCheck)(action);
            return state;
    }
}
//# sourceMappingURL=reducer.js.map